var geocoder,
    mapContact,
    iconTemplate;

function initMap() {
  mapContact = new google.maps.Map(document.getElementById('mapContact'), {
    zoom: 11,
    scrollwheel: false,
    center: new google.maps.LatLng(48.8589507, 2.2775175),
    mapTypeId: google.maps.MapTypeId.ROADMAP
  });

  iconTemplate = {
      path: "M25.5,0c-13.8,0-25,11.2-25,25c0,23.9,25,55,25,55s25-31.1,25-55C50.5,11.2,39.3,0,25.5,0z",
      fillColor: '#595959',
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 0.5,
      size: new google.maps.Size(25, 40),
      labelOrigin: new google.maps.Point(25, 28),
      anchor: new google.maps.Point(0, 40)
  };

  geocoder = new google.maps.Geocoder();

  //this part runs when the mapobject is created and rendered
  google.maps.event.addListenerOnce(mapContact, 'tilesloaded', function(){
    //Put markers on a map
    putMarkersOnMap(mapContact, allMarks)
  })
}

function putMarkersOnMap(map, allMarks) {
  var markers = [],
    time = 200;

  allMarks.forEach(function(item, i) {

    window.setTimeout(function(){
      markers.push(getMarker(map, item, i+1, function(content, marker) {
        setInfoWindow(map, marker, item.content);  
      }));
    }, i * time);
  });
};

function getMarker(map, settings, index, cb) {
  var labelSettings, markerSettings;
  geocoder.geocode({'address': settings.address}, function(results, status) {

    if (status !== google.maps.GeocoderStatus.OK) {
      alert('Geocode was not successful for the following reason: ' + status);
      return false;      
    }

    labelSettings = {
      text: index.toString() || "",
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold'
    };

    markerSettings = {
      animation: google.maps.Animation.DROP,
      position: results[0].geometry.location,
      label: labelSettings,
      icon: iconTemplate,
      optimized: false,
      map: map
    };

    var marker = new google.maps.Marker(markerSettings);

      var el = document.getElementById( settings.id );
      $(el).attr('data-lat', results[0].geometry.location.lat);
      $(el).attr('data-lng', results[0].geometry.location.lng);

    cb( map, marker, settings.content);
    return marker;
  });
};

function setInfoWindow(map, marker, content) {
  var  infowindow = new google.maps.InfoWindow();
  
  marker.addListener('click', function() {
    infowindow.setContent(content);
    infowindow.open(map, marker);
  });
};

function geocodeAddress(resultsMap, target) {
  var lat = $(target).closest('.marker').attr('data-lat');
  var lng = $(target).closest('.marker').attr('data-lng');
  var location = new google.maps.LatLng(lat, lng);
  resultsMap.setCenter(location);
};